import React from 'react';
import ProductDetailPanel from '../../ProductDetailPanel';
import ImgUploadForm from '../../../../../components/form/ImgUploadForm';
import CountOfTotal from '../../../../../components/CountOfTotal';
import { formRequiredRules } from '../../../../../lib/formRules';
import {
  MAXIMUM_NUMBER_OF_PRODUCT_MAIN_IMG,
  MAXIMUM_NUMBER_OF_PRODUCT_SUB_IMG,
  MINIMUM_HEIGHT_OF_INPUT_PRODUCT_THUMBNAIL_IMG,
  MINIMUM_NUMBER_OF_PRODUCT_MAIN_IMG,
  MINIMUM_WIDTH_OF_INPUT_PRODUCT_THUMBNAIL_IMG,
  PRODUCT_DETAIL_PAGE_PANEL_NAME,
  PRODUCT_THUMBNAIL_IMG_HEIGHT,
  PRODUCT_THUMBNAIL_IMG_WIDTH,
} from '../../../../../constants/service/app/productConstants';
import { REQUIRED_MSG } from '../../../../../constants/service/common/formRulesConstants';
import { IMAGE_SIZE_GUIDE_TEXT, IMAGE_TYPE_GUIDE_TEXT } from '../../../../../constants/service/common/commonConstants';

const ProductImg = (props) => {
  const { isEditable, form, initialValue, isCompare, ...res } = props;
  const { mainImg } = initialValue;
  const subImg = form.getFieldValue('subImg');

  return (
    <ProductDetailPanel
      name={PRODUCT_DETAIL_PAGE_PANEL_NAME.PRO_IMG}
      className="product-detail-img"
      title="상품 이미지"
      isCompare={isCompare}
      {...res}
    >
      <div className="panel-body">
        {/*대표 이미지*/}
        <ImgUploadForm
          form={form}
          name="mainImg"
          label="대표 이미지"
          initialValue={mainImg}
          modalTitle="대표 이미지"
          maxCnt={MAXIMUM_NUMBER_OF_PRODUCT_MAIN_IMG}
          minCnt={MINIMUM_NUMBER_OF_PRODUCT_MAIN_IMG}
          targetSize={{
            width: PRODUCT_THUMBNAIL_IMG_WIDTH,
            height: PRODUCT_THUMBNAIL_IMG_HEIGHT,
          }}
          restriction={{
            widthMin: MINIMUM_WIDTH_OF_INPUT_PRODUCT_THUMBNAIL_IMG,
            heightMin: MINIMUM_HEIGHT_OF_INPUT_PRODUCT_THUMBNAIL_IMG,
          }}
          rules={[formRequiredRules(true, REQUIRED_MSG, false)]}
          isEditable={isEditable}
          cropMode={true}
          isProductAttachment={true}
          subContent={
            <div className="sub-info">
              <div>*비율 가로1:세로1</div>
              <div>*권장 크기: 800 x 800 px(권장 크기보다 작을 경우, 앱에서 화질 저하의 우려가 있습니다.)</div>
              <div>*{IMAGE_SIZE_GUIDE_TEXT}</div>
              <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
            </div>
          }
        />

        {/*추가 이미지*/}
        <ImgUploadForm
          form={form}
          name="subImg"
          label={
            <span>
              추가이미지
              <CountOfTotal content={subImg} maxCnt={MAXIMUM_NUMBER_OF_PRODUCT_SUB_IMG} />
            </span>
          }
          initialValue={initialValue.subImg}
          modalTitle="추가 이미지"
          maxCnt={MAXIMUM_NUMBER_OF_PRODUCT_SUB_IMG}
          targetSize={{
            width: PRODUCT_THUMBNAIL_IMG_WIDTH,
            height: PRODUCT_THUMBNAIL_IMG_HEIGHT,
          }}
          restriction={{
            widthMin: MINIMUM_WIDTH_OF_INPUT_PRODUCT_THUMBNAIL_IMG,
            heightMin: MINIMUM_HEIGHT_OF_INPUT_PRODUCT_THUMBNAIL_IMG,
          }}
          isEditable={isEditable}
          cropMode={true}
          isProductAttachment={true}
          subContent={
            <div className="sub-info">
              <div>*비율 가로1:세로1</div>
              <div>*권장 크기: 800 x 800 px(권장 크기보다 작을 경우, 앱에서 화질 저하의 우려가 있습니다.)</div>
              <div>*{IMAGE_SIZE_GUIDE_TEXT}</div>
              <div>*{IMAGE_TYPE_GUIDE_TEXT}</div>
              <div>*추가 이미지는 최대 5개까지 저장할 수 있습니다.</div>
            </div>
          }
        />
      </div>
    </ProductDetailPanel>
  );
};

export default ProductImg;
